import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

import access from "./modules/access";
import appointment from "./modules/appointment";
import archive from "./modules/archive";
import attendance from "./modules/attendance";
import auth from "./modules/auth";
import backup from "./modules/backup";
import check from "./modules/check";
import coldroom from "./modules/coldroom";
import credit from "./modules/credit";
import customer from "./modules/customer";
import deposit from "./modules/deposit";
import delivery from "./modules/delivery";
import discount from "./modules/discount";
import employee from "./modules/employee";
import expense from "./modules/expense";
import invoice from "./modules/invoice";
import item from "./modules/item";
import message from "./modules/message";
import notification from "./modules/notification";
import order from "./modules/order";
import payment from "./modules/payment";
import production from "./modules/production";
import purchase from "./modules/purchase";
import rawMaterial from "./modules/rawMaterial";
import quotation from "./modules/quotation";
import repair from "./modules/repair";
import report from "./modules/report";
import transaction from "./modules/transaction"
import troubleshooting from "./modules/troubleshooting";
import sale from "./modules/sale";
import section from "./modules/section";
import setting from "./modules/setting";
import service from "./modules/service";
import society from "./modules/society";
import slaughter from "./modules/slaughter";
import statistic from "./modules/statistic";
import stock from "./modules/stock";
import supplier from "./modules/supplier";
import user from "./modules/user";
import vehicle from "./modules/vehicle";
import share from "./modules/share";
import history from "./modules/history";

export default new Vuex.Store({
  state: {},
  getters: {
    userRole: (state, getters) => getters["auth/getUserRole"],
    settings: (state, getters) => getters["auth/getSettings"],
  },
  mutations: {},
  actions: {},
  modules: {
    access,
    appointment,
    archive,
    attendance,
    auth,
    backup,
    check,
    customer,
    credit,
    coldroom,
    deposit,
    delivery,
    discount,
    employee,
    expense,
    invoice,
    item,
    message,
    notification,
    order,
    payment,
    production,
    purchase,
    rawMaterial,
    quotation,
    repair,
    report,
    transaction,
    troubleshooting,
    sale,
    section,
    setting,
    service,
    society,
    slaughter,
    statistic,
    stock,
    supplier,
    user,
    vehicle,
    share,
    history,
  },

  plugins: [
    (store) => {
      store.$api = Vue.prototype.$api;
    },
  ],
});
